import { render, staticRenderFns } from "./transaction-amount-report.vue?vue&type=template&id=54c12bac&"
import script from "./transaction-amount-report.vue?vue&type=script&lang=js&"
export * from "./transaction-amount-report.vue?vue&type=script&lang=js&"
import style0 from "./transaction-amount-report.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports